import { useEffect } from "react";
export const useVisibilityEvent = ({ cb, type }) => {
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === type) {
                cb();
            }
        };
        window.addEventListener("visibilitychange", handleVisibilityChange);
        return () => {
            window.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [cb, type]);
};
